import SectionTextImageSocialProofHero from "apps/website/components/section/SectionTextImageSocialProofHero/SectionTextImageSocialProofHero";
import {
  textImageSocialProofHeroData,
} from "apps/website/components/section/SectionTextImageSocialProofHero/shared/data";

export default function SectionQualityOrigins() {
  return (
    <SectionTextImageSocialProofHero
      { ...textImageSocialProofHeroData}
      title="A `happier,` `healthier` cat, ``One fresh meal at a time."
    />
  );
}
